import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/landing/rv-community/cta-back.webp";
import { Link } from "gatsby";

function Ctacommunity({ handleShow }) {
  return (
    <section className="cta_community p-100 text_white">
      <Container>
        <div
          className="cta-comm-main"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Row>
            <Col
              xs={12}
              md={8}
              lg={7}
              xl={6}
              xxl={6}
              className="m-auto text-center"
            >
              <h2>Be a Part of a Leading Community!</h2>
              <p>
                Get an edge from the competition and excel in your domain with
                Revol Ventures.
              </p>
              <button
                onClick={handleShow}
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Join Now!
              </button>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Ctacommunity;
